import createImageUrlBuilder from '@sanity/image-url'
import { SanityAsset, SanityImageObject, type SanityImageSource } from '@sanity/image-url/lib/types/types'
import { ResolvedOpenGraph } from 'next/dist/lib/metadata/types/opengraph-types'

export const imageBuilder = createImageUrlBuilder({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
  dataset: process.env.NEXT_PUBLIC_SANITY_PROJECT_DATASET || 'production',
})

export const imageQuality = 75

export const urlForImage = (source: SanityImageSource, quality: number = imageQuality) => {
  // Ensure that source image contains a valid reference or URL
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (!((source as any)?.asset?._ref || (source as any)?.asset?.url)) {
    return undefined
  }

  return imageBuilder?.image(source)?.auto('format')?.quality(quality)
}

export function resolveOpenGraphImage(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  source: SanityImageObject | any,
  alt?: string,
  width = 1200,
  height = 630,
  quality: number = imageQuality,
): NonNullable<ResolvedOpenGraph['images']>[number] | undefined {
  // Configure the image builder to generate the image URL
  // @see https://www.sanity.io/docs/image-urls
  const url = urlForImage(source)?.width(width)?.height(height)?.fit('crop')?.quality(quality)?.url()

  if (!url) {
    return undefined
  }

  return { url, alt: source?.alt || alt, width, height }
}

export type { SanityAsset, SanityImageObject }
